import * as React from 'react'

function SvgEnterpriseConnectionsMobileHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 375 476"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 476V26.303S156.061 7.228 374.985.397v387.089C156.605 425.716 0 476 0 476z"
        fill="url(#prefix__paint0_radial)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-101.776 626.706 -158.627) scale(414.92 1950.46)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgEnterpriseConnectionsMobileHeroBG
